module.exports = __webpack_public_path__ + "img/ring_y_o_1_0@3x.cb3cb2cd.png";